import React from 'react';

import parseUrl from 'parse-url';

import type { PureLinkProperties } from './PureLink.types';

export const PureLink: React.FC<PureLinkProperties> = ({
  dataTest = 'pure_link',
  to,
  onClick,
  children,
  id,
  target,
  rel,
  referrerPolicy,
  style,
}) => {
  const url = React.useMemo(() => (to ? parseUrl(to, true).href : ''), [to]);

  return (
    <a
      data-testid={dataTest}
      href={url}
      onClick={onClick}
      id={id ?? dataTest}
      target={target}
      rel={rel}
      referrerPolicy={referrerPolicy}
      style={style}
    >
      {children}
    </a>
  );
};
